// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One column on phones; city + province side by side from tablet width up */
.building-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  padding-bottom: var(--ion-safe-area-bottom);
}
@media (min-width: 576px) {
  .building-form {
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  }
}
.building-form ion-input {
  --border-radius: 10px;
  --highlight-color-focused: var(--ion-color-primary);
  min-height: 56px;
}
.building-form__full {
  grid-column: 1/-1;
}

/* Energy class / BACS: outlined like the inputs (56px, 10px radius, label on the border);
 * the value is the coloured chip, the popup opens on click */
.picker-field {
  --field-border-color: var(--ion-color-step-300, var(--ion-background-color-step-300, #b3b3b3));
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  margin: 4px 0 0;
  padding: 8px 44px 8px 16px;
  border: 1px solid var(--field-border-color);
  border-radius: 10px;
  background: var(--ion-background-color, #fff);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.picker-field:hover:not(:disabled) {
  --field-border-color: var(--ion-color-step-750, var(--ion-background-color-step-750, #404040));
}
.picker-field:focus-visible {
  --field-border-color: var(--ion-color-primary);
  outline: none;
  box-shadow: 0 0 0 1px var(--ion-color-primary);
}
.picker-field:disabled {
  cursor: default;
  opacity: 0.6;
}
.picker-field__label {
  position: absolute;
  top: 0;
  left: 12px;
  max-width: calc(100% - 24px);
  padding: 0 4px;
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1;
  /* Filled: primary colour, like the floating labels of the filled inputs */
  color: var(--ion-color-primary);
  background: var(--ion-background-color, #fff);
  pointer-events: none;
}
.picker-field {
  /* Empty: the label sits inside the field, like the floating labels of the inputs above
   * (dark, full size), so it does not look disabled */
}
.picker-field--empty .picker-field__label {
  position: static;
  max-width: none;
  padding: 0;
  transform: none;
  font-size: 16px;
  line-height: 1.3;
  color: var(--ion-text-color, #000);
  background: transparent;
  white-space: normal;
}
.picker-field__chip {
  height: auto;
  min-height: 28px;
  margin: 0;
  padding: 4px 12px;
  border-radius: 8px;
  white-space: normal;
  pointer-events: none;
}
.picker-field__chevron {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: var(--ion-color-medium-shade);
  pointer-events: none;
}

/* Energy class colours */
.ion-chip-g,
.ion-chip-f,
.ion-chip-e,
.ion-chip-d,
.ion-chip-c,
.ion-chip-b,
.ion-chip-a,
.ion-chip-ap,
.ion-chip-app,
.ion-chip-appp,
.ion-chip-bacs-d,
.ion-chip-bacs-c,
.ion-chip-bacs-b,
.ion-chip-bacs-a {
  color: #fff;
  font-weight: bold;
}

.ion-chip-g {
  background-color: #e30f22;
}

.ion-chip-f {
  background-color: #bc4c4a;
}

.ion-chip-e {
  background-color: #e36c0e;
}

.ion-chip-d {
  background-color: #ffc118;
}

.ion-chip-c {
  background-color: #eded1d;
}

.ion-chip-b {
  background-color: #99cc18;
}

.ion-chip-a {
  background-color: #00cc15;
}

.ion-chip-ap {
  background-color: #01950d;
}

.ion-chip-app {
  background-color: #005f05;
}

.ion-chip-appp {
  background-color: #2c5e00;
}

/* BACS colours */
.ion-chip-bacs-d {
  background-color: #eed216;
}

.ion-chip-bacs-c {
  background-color: #9fc520;
}

.ion-chip-bacs-b {
  background-color: #5fb230;
}

.ion-chip-bacs-a {
  background-color: #1d9237;
}`, "",{"version":3,"sources":["webpack://./src/components/form-components/form-edit-building/form-edit-building.component.scss"],"names":[],"mappings":"AAAA,4EAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,2CAAA;AACF;AACE;EANF;IAOI,oDAAA;EAEF;AACF;AAAE;EACE,qBAAA;EACA,mDAAA;EACA,gBAAA;AAEJ;AACE;EACE,iBAAA;AACJ;;AAGA;6DAAA;AAEA;EACE,8FAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,2CAAA;EACA,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AADF;AAGE;EACE,8FAAA;AADJ;AAIE;EACE,8CAAA;EACA,aAAA;EACA,8CAAA;AAFJ;AAKE;EACE,eAAA;EACA,YAAA;AAHJ;AAME;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,4BAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,0EAAA;EACA,+BAAA;EACA,6CAAA;EACA,oBAAA;AAJJ;AA7CA;EAoDE;sDAAA;AAHF;AAKE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAME;EACE,YAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,oCAAA;EACA,oBAAA;AALJ;;AASA,yBAAA;AACA;;;;;;;;;;;;;;EAcE,WAAA;EACA,iBAAA;AANF;;AASA;EAAc,yBAAA;AALd;;AAMA;EAAc,yBAAA;AAFd;;AAGA;EAAc,yBAAA;AACd;;AAAA;EAAc,yBAAA;AAId;;AAHA;EAAc,yBAAA;AAOd;;AANA;EAAc,yBAAA;AAUd;;AATA;EAAc,yBAAA;AAad;;AAZA;EAAe,yBAAA;AAgBf;;AAfA;EAAgB,yBAAA;AAmBhB;;AAlBA;EAAiB,yBAAA;AAsBjB;;AApBA,iBAAA;AACA;EAAmB,yBAAA;AAwBnB;;AAvBA;EAAmB,yBAAA;AA2BnB;;AA1BA;EAAmB,yBAAA;AA8BnB;;AA7BA;EAAmB,yBAAA;AAiCnB","sourcesContent":["/* One column on phones; city + province side by side from tablet width up */\n.building-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 16px;\n  padding-bottom: var(--ion-safe-area-bottom);\n\n  @media (min-width: 576px) {\n    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  }\n\n  ion-input {\n    --border-radius: 10px;\n    --highlight-color-focused: var(--ion-color-primary);\n    min-height: 56px;\n  }\n\n  &__full {\n    grid-column: 1 / -1;\n  }\n}\n\n/* Energy class / BACS: outlined like the inputs (56px, 10px radius, label on the border);\n * the value is the coloured chip, the popup opens on click */\n.picker-field {\n  --field-border-color: var(--ion-color-step-300, var(--ion-background-color-step-300, #b3b3b3));\n\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 56px;\n  margin: 4px 0 0;\n  padding: 8px 44px 8px 16px;\n  border: 1px solid var(--field-border-color);\n  border-radius: 10px;\n  background: var(--ion-background-color, #fff);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    --field-border-color: var(--ion-color-step-750, var(--ion-background-color-step-750, #404040));\n  }\n\n  &:focus-visible {\n    --field-border-color: var(--ion-color-primary);\n    outline: none;\n    box-shadow: 0 0 0 1px var(--ion-color-primary);\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.6;\n  }\n\n  &__label {\n    position: absolute;\n    top: 0;\n    left: 12px;\n    max-width: calc(100% - 24px);\n    padding: 0 4px;\n    transform: translateY(-50%);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    line-height: 1;\n    /* Filled: primary colour, like the floating labels of the filled inputs */\n    color: var(--ion-color-primary);\n    background: var(--ion-background-color, #fff);\n    pointer-events: none;\n  }\n\n  /* Empty: the label sits inside the field, like the floating labels of the inputs above\n   * (dark, full size), so it does not look disabled */\n  &--empty &__label {\n    position: static;\n    max-width: none;\n    padding: 0;\n    transform: none;\n    font-size: 16px;\n    line-height: 1.3;\n    color: var(--ion-text-color, #000);\n    background: transparent;\n    white-space: normal;\n  }\n\n  &__chip {\n    height: auto;\n    min-height: 28px;\n    margin: 0;\n    padding: 4px 12px;\n    border-radius: 8px;\n    white-space: normal;\n    pointer-events: none;\n  }\n\n  &__chevron {\n    position: absolute;\n    right: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 18px;\n    color: var(--ion-color-medium-shade);\n    pointer-events: none;\n  }\n}\n\n/* Energy class colours */\n.ion-chip-g,\n.ion-chip-f,\n.ion-chip-e,\n.ion-chip-d,\n.ion-chip-c,\n.ion-chip-b,\n.ion-chip-a,\n.ion-chip-ap,\n.ion-chip-app,\n.ion-chip-appp,\n.ion-chip-bacs-d,\n.ion-chip-bacs-c,\n.ion-chip-bacs-b,\n.ion-chip-bacs-a {\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-g { background-color: #e30f22; }\n.ion-chip-f { background-color: #bc4c4a; }\n.ion-chip-e { background-color: #e36c0e; }\n.ion-chip-d { background-color: #ffc118; }\n.ion-chip-c { background-color: #eded1d; }\n.ion-chip-b { background-color: #99cc18; }\n.ion-chip-a { background-color: #00cc15; }\n.ion-chip-ap { background-color: #01950d; }\n.ion-chip-app { background-color: #005f05; }\n.ion-chip-appp { background-color: #2c5e00; }\n\n/* BACS colours */\n.ion-chip-bacs-d { background-color: #eed216; }\n.ion-chip-bacs-c { background-color: #9fc520; }\n.ion-chip-bacs-b { background-color: #5fb230; }\n.ion-chip-bacs-a { background-color: #1d9237; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
